import React, { useEffect, useState } from 'react';
import { ArrowRight as IconRight } from "flowbite-react-icons/outline";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from 'react-i18next';
import CustomButton from "../../components/CustomButton";
import RadioButton from "../../components/RadioButton";
import Loading from "../../components/Loading";
import LocalBreadcrumbs from "../../components/Breadcrumbs/LocalBreadcrumbs";
import {getLanguage} from "../../lang/helpers";
import Api from "../../services/Api";

interface Question {
  en: string
  sv: string

}

interface Option {
  en: string
  sv: string
  score: number
}

// interface ClientInterface {
//   id: string;
//   firstName: string;
//   lastName: string;
// }

export default function Readiness() {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState<Array<Question>>([]);
  const [options, setOptions] = useState<Array<Option>>([]);
  const [answers, setAnswers] = useState<Array<number>>([]);
  const [categoryNameEn, setCategoryNameEn] = useState<string>("");
  const [categoryNameSv, setCategoryNameSv] = useState<string>("");
  const [customerName, setCustomerName] = useState<string>("");
  const { categoryId } = useParams();
  const { t, i18n } = useTranslation();
  const lang = getLanguage(i18n.language)
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    let url = "client/readiness/" + categoryId;
    api.get(url).then((response) => {
      setQuestions(response.json.questions);
      setOptions(response.json.options);
      setAnswers(response.json.answers);
      setCustomerName(response.json.customerName);
      setCategoryNameEn(response.json.categoryNameEn);
      setCategoryNameSv(response.json.categoryNameSv);
      setLoaded(true)
    });
  }, []);

  const selectOption = (questionNr: number, score: number) => {
    const _answers = [...answers];
    _answers[questionNr] = score;
    setAnswers(_answers);
  }

  if (!loaded) {
    return <Loading />;
  }

  const crumbs = [
    {name: lang === "sv" ? "Hem" : "Home", url: "/"},
    {name: t("assessments"), url: "/assessments"},
    {name: "Readiness"},
  ]

  const pageDone = () => {
    for (const answer of answers) {
      if (answer < 0) {
        return false;
      }
    }
    return true;
  }

  const renderIntro = () => {
    let intro = "";
    let disclaimer = "";
    if (lang === 'sv') {
      intro += "Ange i vilken grad du instämmer i påståendena nedan, utifrån hur det ser ut för dig just nu inför arbetet med initiativet ";
      intro += categoryNameSv;
      intro += " på ";
      intro += customerName;
      intro += ". Det finns inga rätta eller felaktiga svar, det är din upplevelse som räknas."

      disclaimer += "Ingen på " + customerName + " kan se vem som svarat vad."
    } else {
      intro += "Rate how much you agree with the statements below, based on where things stand for you right now with the ";
      intro += categoryNameEn;
      intro += " initiative at ";
      intro += customerName;
      intro += ". There are no right or wrong answers, it’s your experience that counts."

      disclaimer += "No one at " + customerName + " can see who answered what."
    }


    return (
      <>
        <p className="my-2 z-body1">{intro}</p>
        <p className="my-2 z-body1">{disclaimer}</p>
      </>
    )
  }

  const save = () => {
    let url = "client/readiness_save/" + categoryId;
    const data = {
      answers: answers,
    }
    api.post(url, data).then((response) => {
      navigate("/assessments")
    });
  }

  return (
    <div className="main-content">
      <LocalBreadcrumbs crumbs={crumbs}/>
      <p className="z-h2 mt-4">{lang === "sv" ? "Förutsättningar" : "Readiness"}</p>
      {renderIntro()}
      {
        questions.map((question, questionNr) => {
          return (
            <div key={"question_" + questionNr} className="mt-6">
              <div className="z-title1">
                {lang === "sv" ? question.sv : question.en}
              </div>
              {
                options.map(option => {
                  // Don't show cannot answer
                  if (option.score === 0) {
                    return null;
                  }
                  const _selectedScore = answers[questionNr]
                  return (
                    <div className="mt-2" key={"a_" + questionNr + '_' + option.score}>
                      <RadioButton
                        id={"a_" + questionNr + '_' + option.score}
                        name={"a_" + questionNr + '_' + option.score}
                        label={lang === "sv" ? option.sv : option.en}
                        value={"" + option.score}
                        checked={_selectedScore === option.score}
                        onChange={() => selectOption(questionNr, option.score)} // Set to 1 for "A lot"
                      />
                      </div>
                  )
                })
              }
            </div>
          )
        })
      }

      <div className="flex justify-between mt-6">

        <div className="w-40">
          <CustomButton disabled={!pageDone()} onClick={() => save()}
                        rightIcon={<IconRight className="size-4 text-neutral-900!" aria-hidden="true" />}>
            {t('submit')}
          </CustomButton>
        </div>

      </div>
    </div>
  )
}
